import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Heading from '../forms/Heading';
import Row from './Row';
import Col from './Col';
import Closable from '../Clossable';
import Icon from '../forms/Icon';

const Wrapper = styled(Col)`
    position: relative;
    
    padding: 0.2em 0.3em;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    border-radius: 0.4rem;

    gap: ${({ collapse }) => collapse ? '0em' : `0.5em`};
    background: ${({ theme }) => theme.body};

    &:hover {
        background: ${({ collapse, theme }) => collapse ? theme.gray + '0a' : ''};
    }
`;

const Header = styled(Row)`
    cursor: pointer;
    justify-content: space-between;
    // padding: 0.2em;
`;

const Content = styled(Col)`
    max-height: ${({ collapse, maxHeight }) => (collapse ? '0px' : `${maxHeight}px`)};
    transition: max-height 0.2s ease-in-out;
    padding-left: 0.5em;
    border-left: ${({ collapse }) => (collapse ? '0px' : `1px`)} solid ${({ theme }) => theme.gray}40;

    // min-width: 8em;
    // overflow: auto;
`;
const Close = styled(Closable)`
    opacity: 0.5;
    transition: all 0.2s;
    &:hover {
        opacity: 1;
    }
`;
const I = styled(Icon)`
    transform: rotate(${({ rotate }) => rotate ? 0 : 180}deg);
    opacity: 0.5;
    transition: all 0.2s;
    &:hover {
        opacity: 1;
    }`

const Collapsible = ({ children, ...props }) => {
    const contentRef = useRef(null);
    const [state, setState] = useState(props.startState ?? true);
    const [contentHeight, setContentHeight] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            // setContentHeight(Math.min(500, contentRef.current.scrollHeight + 10));
            setContentHeight(500);
        }
    }, [children, state]);

    if (children.length === 0) return props.label;

    return (
        <Wrapper collapse={state} {...props}>
            <Header onClick={() => setState(!state)}>
                <Heading style={{ width: '100%' }}>{props.label}</Heading>
                <I icon='chevronDown' rotate={state ? 1 : 0} />
            </Header>
            <Content collapse={state} maxHeight={contentHeight}>
                <div style={{ overflow: (contentHeight < 500 ? 'auto' : 'auto') }} ref={contentRef}>
                    <Col style={{ gap: props.colGap || '0.5em' }}>
                        {/* {!state ? children : null} */}
                        {children}
                    </Col>
                </div>
            </Content>
        </Wrapper>
    );
};

export default Collapsible;
